import { render, staticRenderFns } from "./CustomerAvatar.vue?vue&type=template&id=20f9b7a8"
import script from "./CustomerAvatar.vue?vue&type=script&lang=js"
export * from "./CustomerAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports